import { TourType } from '../../types/onboarding';

// The page that contains each tour's targets. Intro and navigation tours start on the dashboard.
export const tourRoutes: Record<TourType, string> = {
  [TourType.FIRST_LOGIN]: '/',
  [TourType.OVERVIEW]: '/',
  [TourType.SIDEBAR]: '/',
  [TourType.CONVERSATIONS]: '/conversations',
  [TourType.AGENTS]: '/agents',
  [TourType.SETTINGS]: '/settings',
  [TourType.REPORTS]: '/reports',
  [TourType.RECORDS]: '/records',
  [TourType.DOCUMENTS]: '/verification',
  [TourType.CALENDAR]: '/call-requests',
  [TourType.SCHEDULER]: '/scheduler',
  [TourType.LOGS]: '/logs',
  [TourType.TEAMS]: '/teams'
};
